export const ListEventName = {
  jaywalking: {
    label: '무단횡단',
    color: 'accentBlue',
  },
  speeding: {
    label: '속도 위반',
    color: 'accentYellow',
  },
  suddentStop: {
    label: '돌발정차',
    color: 'accentGrape',
  },
  wrongWay: {
    label: '역주행',
    color: 'accentCyan',
  },
  illegalParking: {
    label: '불법주정차',
    color: 'accentOrange',
  },
  pm10badEnv: {
    label: '미세먼지 나쁨',
    color: 'accentBlue',
  },
  pm10veryBadEnv: {
    label: '미세먼지 매우 나쁨',
    color: 'accentSoftYellow',
  },
  pm25badEnv: {
    label: '초미세먼지 나쁨',
    color: 'accentSoftGrape',
  },
  pm25veryBadEnv: {
    label: '초미세먼지 매우 나쁨',
    color: 'accentCyan',
  },
  pm10bad: {
    label: 'PM 10 나쁨',
    color: 'accentSoftGreen',
  },
  pm10veryBad: {
    label: 'PM 10 매우 나쁨',
    color: 'accentSoftRed',
  },
  pm25bad: {
    label: 'PM 2.5 나쁨',
    color: 'accentSoftYellow',
  },
  pm25veryBad: {
    label: 'PM 2.5 매우 나쁨',
    color: 'accentSoftGrape',
  },
  badFinedust: {
    label: '미세먼지 나쁨',
    color: 'accentBlue',
  },
  veryBadFinedust: {
    label: '미세먼지 매우 나쁨',
    color: 'accentYellow',
  },
  badUltraFinedust: {
    label: '초미세먼지 나쁨',
    color: 'accentSoftGrape',
  },
  veryBadUltraFinedust: {
    label: '초미세먼지 매우 나쁨',
    color: 'accentCyan',
  },
} as const;

export type EventName = keyof typeof ListEventName;

////////////////// PSC Dahboard \\\\\\\\\\\\\\\\\\\

// Presentation-only (color/bg) per event type - cm_code is the source of
// truth for the display *text*, resolved server-side and passed as
// eventTypeLabel/statusLabel; these keys only pick styling. See CLAUDE.md's
// "Integration architecture" section and postgres/initdb/README_CM_CODE.md.
export const ListEventTypes = {
  incoming: {
    color: 'danger',
    bg: '#FF3B301A',
  },
  registered: {
    color: 'warning',
    bg: '#FC66051A',
  },
  dispatched: {
    color: 'yellowPrimary',
    bg: '#E0B3001A',
  },
  arrived: {
    color: 'bluePrimary',
    bg: '#ffffff',
  },
  patient_handled: {
    color: 'bluePrimary',
    bg: '#ffffff',
  },
  transfer: {
    color: 'bluePrimary',
    bg: '#ffffff',
  },
  arrived_at_hospital: {
    color: 'bluePrimary',
    bg: '#ffffff',
  },
  finished: {
    color: 'greenPrimary',
    bg: '#ffffff',
  },
  rejected: {
    color: 'danger',
    bg: '#ffffff',
  },
  completed: {
    color: 'greenPrimary',
    bg: '#ffffff',
  },
} as const;

export type EventTypes = keyof typeof ListEventTypes;

// cm_language tags per event type - used wherever the status is rendered from
// the frontend key instead of a server-resolved label (BubbleEvent,
// RunningText). The wording lives in System Management > Language.
export const EventTypeTags: Record<EventTypes, string> = {
  incoming: 'psc>report status>incoming',
  registered: 'psc>report status>registered',
  dispatched: 'psc>report status>dispatched',
  arrived: 'psc>report status>arrived',
  patient_handled: 'psc>report status>patient handled',
  transfer: 'psc>report status>transfer',
  arrived_at_hospital: 'psc>report status>arrived at healthcare',
  finished: 'psc>report status>finished',
  rejected: 'psc>report status>rejected',
  completed: 'psc>report status>completed',
};

// status ambulance - presentation-only (color); see note above ListEventTypes.
export const StatusAmbulance = {
  requested: {
    color: 'bluePrimary',
  },
  accepted: {
    color: 'bluePrimary',
  },
  rejected: {
    color: 'danger',
  },
  arrived: {
    color: 'bluePrimary',
  },
  patient_handled: {
    color: 'bluePrimary',
  },
  transfer: {
    color: 'bluePrimary',
  },
  arrived_at_hospital: {
    color: 'bluePrimary',
  },
  finished: {
    color: 'greenPrimary',
  },
} as const;

export type AmbulanceTypes = keyof typeof StatusAmbulance;

// list ambulance status management \\\\\\\\\\
export const StatusAmbulanceDriver = {
  ongoing: {
    label: 'on-going',
    color: 'bluePrimary',
  },
  standby: {
    label: 'standby',
    color: 'greenPrimary',
  },
  maintenance: {
    label: 'maintenance',
    color: 'warning',
  },
  offline: {
    label: 'offline',
    color: 'greyPrimary',
  },
  requested: {
    label: 'requested',
    color: 'yellowPrimary',
  },
} as const;

export type AmbulanceDriverTypes = keyof typeof StatusAmbulanceDriver;
